import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { addPageLoader } from 'src/lib/flow/loaders';
import { yourHome } from 'src/lib/flow/text';
import { updateAnswersCompleted } from 'src/store/apiUtils';

import { FlowContext } from '../../../../lib/flow';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `When do you need to sell ${yourHome(answers, channel)}?`;
}

function subtitle() {
  return 'This won’t affect your offer. We’re here to help with any timeline.';
}

const saleTimelinePage: FlowPage = {
  slug: () => 'sale-timeline',
  isEnabled,
  autoAdvance: () => true,
  title,
  subtitle,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.sale_timeline',
      type: 'radio_single_select',
      options: [
        {
          label: 'ASAP',
          value: 'ASAP',
        },
        {
          label: '2-4 weeks',
          value: '2 - 4 Weeks',
        },
        {
          label: '4-6 weeks',
          value: '4 - 6 Weeks',
        },
        {
          label: '6+ weeks',
          value: '6+ Weeks',
        },
        {
          label: 'Just browsing',
          value: 'Just Browsing',
        },
      ],
    },
  ],
};

addPageLoader('sale-timeline', 'sale-timeline-update-answers', async (listenerApi) => {
  // wait for submit answers to complete, so we can know whether or not exitpath should be used for partnership denials
  // only call updateAnswersCompleted if one or more of the eligibility criteria was selected
  const state = listenerApi.getState();
  const eligibilityCriteria = state.sellerInput.changedAnswers['home.eligibility_criteria'];
  if (eligibilityCriteria && eligibilityCriteria['_none_'] !== true) {
    await updateAnswersCompleted(listenerApi);
  }
});

export default saleTimelinePage;
